import { createAvatar } from "../utils/avatarUtils";

// Employee data — from the server-confirmed profile (/users/me) only; the
// shell renders once SessionGate has it. A missing value is shown as "--",
// never replaced by a stored value or a placeholder identity.
export const useEmployeeProfileData = (profile) => {
  const _phone     = profile?.employeePhone        || "";
  const _emergency = profile?.emergencyPhoneNumber || "";
  const _name      = profile?.employeeName || profile?.employeeArabicName || "";

  const employeeData = {
    id:               profile?.clientCode || profile?.infinityCode || "--",
    name:             _name || "--",
    position:         profile?.position ?? profile?.employeeType ?? "--",
    department:       profile?.department ?? profile?.employeeType ?? "--",
    email:            profile?.employeeEmail                || "--",
    phone:            _phone ? "+20" + _phone : "--",
    address:          profile?.address || profile?.location || "--",
    joinDate:         profile?.hiringDate                   || null,
    employeeId:       profile?.clientCode || profile?.infinityCode || "--",
    manager:          profile?.firstLineManagerName         || "--",
    status:           profile?.employeeState                || "--",
    avatar:           _name ? createAvatar(_name) : "",
    birthDate:        profile?.DoB                          || null,
    nationalId:       profile?.nationalId                   || "--",
    emergencyContact: _emergency ? "+20" + _emergency : "--",
    workLocation:     profile?.location                     || "--",
    firstLevelManager: profile?.firstLineManagerInfinityCode || "--",
  };

  return employeeData;
};
